module.exports = __webpack_public_path__ + "img/workContents03-01_play.57c9367f.gif";